import { Component, OnInit } from '@angular/core';
import { ExtratoService } from '../../extrato/extrato.service';
ExtratoService
@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss'],
})
export class TransactionsComponent implements OnInit {
  public loading: boolean = false;
  public transactions: any[] = [];

  constructor(private extratoService: ExtratoService) {}

  ngOnInit(): void {
    this.loading = true;
    this.extratoService.getLatestTransactions().subscribe({
      next: (response) => {
        this.transactions = response.map((transaction: any) => ({
          ...transaction,
          origem: transaction.origem.toLowerCase(),
        }));
      },
      error: (error) => {
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
